import { useState, useEffect } from 'react'
import { userService } from '../services/userService'
import type { User } from '../types'

export function useUser(id: number) {
  const [data, setData] = useState<User | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      setError(null)
      try {
        const user = await userService.getById(id)
        setData(user)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Error al cargar vendedor')
      } finally {
        setIsLoading(false)
      }
    }
    fetchData()
  }, [id])

  return { data, isLoading, error }
}
